<template>
    <div>
        <Swiper
          class="mb-1.5"
          slides-per-view="auto"
          :space-between="10"
          :free-mode="true"
          :modules="modules"
          :mousewheel="{ forceToAxis: true }"
          :scrollbar="{ enabled: true, draggable: true, el: `#${id}`, hide: true }"
        >
            <SwiperSlide v-for="product in products" class="!w-44 section">
                <div class="w-full p-2">
                    <Link :href="route('products.show', [product])">
                        <div
                          class="flex justify-center h-40 items-center">
                            <ResponsiveImage
                              class="h-36 object-contain object-center"
                              :alt="product.title"
                              :media-item="product.image"
                            />
                        </div>

                        <p class="h-10">
                            <span class="line-clamp-2 text-xs font-semibold mb-3 max-h-10">{{ product.title }}</span>
                        </p>
                        <span class="inline-block bg-green-500 mt-1 font-bold px-1 rounded-md">
                            {{ product.price?.formatted }}
                        </span>
                    </Link>
                </div>
            </SwiperSlide>
        </Swiper>

        <div :id="id" class="h-1 bg-gray-200 rounded-full"></div>
    </div>
</template>

<script>
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/mousewheel';
import 'swiper/css/free-mode';
import {Swiper, SwiperSlide} from "swiper/vue";
import {Link} from "@inertiajs/vue3";
import ResponsiveImage from "@/Components/ResponsiveImage.vue";
import { Mousewheel, FreeMode, Scrollbar } from 'swiper/modules';

export default {
    components: {ResponsiveImage, Link, Swiper, SwiperSlide},
    props: {
        products: Array,
    },
    setup() {
        return {
            id: `horizontal-${Math.random().toString(36).substring(2, 7)}`,
            modules: [Mousewheel, FreeMode, Scrollbar]
        }
    }
}
</script>
